export enum RequestReopenStageId {
    ReopenToUserStageId = '-1',
    ReopenFollowupToUserStageId = '-2'
}